// Implements: F-UIX-019
/**
 * The platform admin's ceiling route (S4d-1), named once for the client and the simulated API:
 * `GET` and `PUT /api/admin/organizations/{org_id}/usage-ceiling`.
 */

import { API_BASE } from "./apiBase";

/** The route with its parameter, as MSW and the tests name it. */
export const CEILING_ROUTE = `${API_BASE}/admin/organizations/:orgId/usage-ceiling`;

/** The ceiling's path for one organization, its id escaped. */
export function ceilingPath(organizationId: string): string {
  return CEILING_ROUTE.replace(":orgId", encodeURIComponent(organizationId));
}
